import {
	isManualCorrectionReadyForReview,
	isManualCorrectionWaiting,
} from './materialValidationContract';

const SCOPE_LABELS = {
	installation_material_pricing: 'Pricing de materiales',
	technician_inventory_completion: 'Cierre técnico de inventario',
	installation_materials: 'Materiales de instalación',
	manual_inventory_correction: 'Corrección manual de materiales',
};

export const getMaterialValidationScopeLabel = scopeKey =>
	SCOPE_LABELS[scopeKey] || 'Validación de materiales';

export const formatMaterialValidationCaseLabel = materialCase => {
	if (!materialCase) return '';
	const identity = `Caso #${materialCase.id} · ${getMaterialValidationScopeLabel(
		materialCase.scopeKey,
	)}`;
	return materialCase.occurrence > 1
		? `${identity} · Repetición ${materialCase.occurrence}`
		: identity;
};

const withCaseIdentity = (label, materialCase) =>
	`${label} · ${formatMaterialValidationCaseLabel(materialCase)}`;

export const formatMaterialValidationValue = (value, unit) => {
	if (value === null || value === undefined) return '—';
	if (unit?.code === 'BOOLEAN') return value === 1 ? 'Sí' : 'No';
	if (unit?.code === 'COUNT')
		return `${value} ${value === 1 ? 'unidad' : 'unidades'}`;
	return `${value}${unit?.code ? ` ${unit.code}` : ''}`;
};

export const getComparisonExpectedLabel = operator => {
	if (operator === 'GTE') return 'Mínimo requerido';
	if (operator === 'LTE') return 'Máximo permitido';
	return 'Esperado';
};

const COMPARISON_CAUSE_LABELS = {
	QUANTITY_DIFFERENCE: 'Cantidad diferente',
	BELOW_MINIMUM: 'Por debajo del mínimo',
};

export const getComparisonOutcomeLabel = comparison => {
	if (comparison?.outcome === 'MATCH') return 'Coincide';
	return (
		COMPARISON_CAUSE_LABELS[comparison?.causeCode] || 'Diferencia detectada'
	);
};

export const getMaterialValidationPresentation = ({
	isLoading,
	loadError,
	contractError,
	viewModel,
} = {}) => {
	if (contractError) return { label: 'Estado no verificable', tone: 'warning' };
	if (loadError) return { label: 'No se pudo confirmar', tone: 'warning' };
	if (isLoading || !viewModel) return { label: 'Consultando', tone: 'neutral' };

	if (viewModel.consistency?.state === 'INCONSISTENT')
		return { label: 'Estado por conciliar', tone: 'warning' };
	if (viewModel.required === false && !viewModel.currentCase)
		return { label: 'No requerida', tone: 'neutral' };

	const materialCase = viewModel.currentCase;
	if (!materialCase) return { label: 'Sin caso vigente', tone: 'warning' };
	if (isManualCorrectionWaiting(viewModel))
		return {
			label: withCaseIdentity('Esperando al técnico', materialCase),
			tone: 'warning',
		};
	if (isManualCorrectionReadyForReview(viewModel))
		return {
			label: withCaseIdentity('Lista para revisión', materialCase),
			tone: 'warning',
		};
	if (materialCase.status === 'APPROVED')
		return {
			label: withCaseIdentity('Aprobada', materialCase),
			tone: 'success',
		};
	if (materialCase.status === 'PENDING_REVIEW')
		return {
			label: withCaseIdentity('Pendiente', materialCase),
			tone: 'warning',
		};
	if (materialCase.status === 'RETURNED_FOR_CORRECTION')
		return {
			label: withCaseIdentity('Devuelta', materialCase),
			tone: 'warning',
		};
	if (materialCase.status === 'SUPERSEDED')
		return {
			label: withCaseIdentity('Reemplazada', materialCase),
			tone: 'neutral',
		};
	if (materialCase.status === 'CANCELED')
		return {
			label: withCaseIdentity('Cancelada', materialCase),
			tone: 'neutral',
		};
	return { label: 'Estado no verificable', tone: 'warning' };
};
